import { ThunkAction } from 'redux-thunk';
import { RootState } from 'store';
import {
  receivedDeleteEnrolmentSuccess,
  receivedDeleteEnrolmentFail,
  receivedGetDatasourcesFail,
  receivedGetDatasourcesSuccess,
  receivedGetEnrolmentsFail,
  receivedGetEnrolmentsSuccess,
  receivedUpdateEnrolmentFail,
  receivedUpdateEnrolmentSuccess,
  TelematicsAction,
  startEnrolmentsLoading,
  startDatasourcesLoading,
  receivedCreateEnrolmentSuccess,
  receivedCreateEnrolmentFail,
} from './actions';
import { DataSources, Enrolment, Enrolments } from 'services/resources';
import { deleteEnrolment, getDataSources, getEnrolments, patchEnrolment, postEnrollment } from './resources';

type TelematicsThunkResult<R> = ThunkAction<Promise<R>, RootState, unknown, TelematicsAction>;

/**
 * Gets a list of data sources
 */
export const listDataSources = (): TelematicsThunkResult<DataSources | void> => (dispatch) => {
  dispatch(startDatasourcesLoading());
  return getDataSources()
    .then((response) => {
      dispatch(receivedGetDatasourcesSuccess(response.results));
      return response.results;
    })
    .catch((response) => {
      dispatch(receivedGetDatasourcesFail(response.data));
    });
};

/**
 * Gets a list of enrolments
 */
export const listEnrolments = (): TelematicsThunkResult<Enrolments | void> => (dispatch) => {
  dispatch(startEnrolmentsLoading());
  return getEnrolments()
    .then((response) => {
      dispatch(receivedGetEnrolmentsSuccess(response.results));
      return response.results;
    })
    .catch((response) => {
      dispatch(receivedGetEnrolmentsFail(response.data));
    });
};

export const enrollVehicle =
  (vehicleId: number): TelematicsThunkResult<Enrolment | void> =>
  (dispatch) => {
    dispatch(startEnrolmentsLoading());
    return postEnrollment(vehicleId)
      .then((response) => {
        dispatch(receivedCreateEnrolmentSuccess(response));
        return response;
      })
      .catch((response) => {
        dispatch(receivedCreateEnrolmentFail(response.data));
        throw new Error('Failed to create enrolment');
      });
  };

/**
 * Updates an enrolment
 */
export const updateEnrolment =
  (enrolmentId: number, data: Partial<Enrolment>): TelematicsThunkResult<Enrolment | void> =>
  (dispatch) => {
    return patchEnrolment(enrolmentId, data)
      .then((response) => {
        dispatch(receivedUpdateEnrolmentSuccess(response));
        return response;
      })
      .catch((response) => {
        dispatch(receivedUpdateEnrolmentFail(response.data));
      });
  };

/**
 * Deletes an enrolment
 */
export const removeEnrolment =
  (enrolmentId: number): TelematicsThunkResult<void> =>
  (dispatch) => {
    return deleteEnrolment(enrolmentId)
      .then(() => {
        dispatch(receivedDeleteEnrolmentSuccess(enrolmentId));
      })
      .catch((response) => {
        dispatch(receivedDeleteEnrolmentFail(response.data));
        throw new Error('Failed to delete enrolment');
      });
  };
